<form
  class="factory-bank-details-form"
  [formGroup]="factoryBankDetailsFormGroup()"
>
  @for (field of factoryBankDetailsFormFields; track $index) {
    @switch (field.type) {
      @case ('text') {
        <mat-form-field
          appearance="outline"
          class="factory-bank-details-form-field"
          [class]="getFieldClass()"
        >
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            [type]="field.inputType"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          >
        </mat-form-field>
      }
      @case ('tel') {
        <mat-form-field
          appearance="outline"
          class="factory-bank-details-form-field"
          [class]="getFieldClass()"
        >
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            appPhoneMask
            [type]="field.inputType"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          >
        </mat-form-field>
      }
      @case ('email') {
        <mat-form-field
          appearance="outline"
          class="factory-bank-details-form-field"
          [class]="getFieldClass()"
        >
          <mat-label>{{ field.label }}</mat-label>
          <input
            matInput
            appEmailMask
            [type]="field.inputType"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          >
        </mat-form-field>
      }
      @case ('textarea') {
        <mat-form-field
          appearance="outline"
          class="factory-bank-details-form-field-textarea"
          [class]="getFieldClass()"
        >
          <mat-label>{{ field.label }}</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            cdkAutosizeMaxRows="3"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          ></textarea>
        </mat-form-field>
      }
    }
  }
  @if (!factoryBankDetailsData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          (click)="handleDeleteData()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        [disabled]="factoryBankDetailsFormGroup().invalid"
        (click)="handleCreateData()"
      >
        Сохранить
      </button>
    </div>
  }
</form>
